"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissions = usePermissions;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var permissions_1 = require("../interfaces/permissions");
function usePermissions() {
    var _a;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.auth; }).user;
    var permissions = (0, react_1.useMemo)(function () {
        var _a;
        if (!((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.permissions)) {
            return [];
        }
        return user.role.permissions;
    }, [(_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.permissions]);
    var hasPermission = function (module, action) {
        var _a;
        if (!user || !permissions.length) {
            return false;
        }
        // Admin role has all permissions
        if (((_a = user.role) === null || _a === void 0 ? void 0 : _a.code) === "admin") {
            return true;
        }
        var modulePermission = permissions.find(function (p) { return p.module === module; });
        if (!modulePermission) {
            return false;
        }
        return modulePermission.actions[action] === true;
    };
    var canAccess = function (module) {
        var _a;
        if (!user || !permissions.length) {
            return false;
        }
        // Admin role has access to all modules
        if (((_a = user.role) === null || _a === void 0 ? void 0 : _a.code) === "admin") {
            return true;
        }
        var modulePermission = permissions.find(function (p) { return p.module === module; });
        if (!modulePermission) {
            return false;
        }
        // Can access if any action is allowed
        return Object.values(modulePermission.actions).some(function (allowed) { return allowed === true; });
    };
    var isAdmin = function () {
        var _a;
        return ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.code) === "admin";
    };
    var isSupervisor = function () {
        var _a, _b;
        return ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.code) === "supervisor" || ((_b = user === null || user === void 0 ? void 0 : user.role) === null || _b === void 0 ? void 0 : _b.code) === "admin";
    };
    var canAuthorizeOrders = function () {
        return hasPermission(permissions_1.MODULES.ORDERS, permissions_1.ACTIONS.AUTHORIZE);
    };
    var userModules = (0, react_1.useMemo)(function () {
        var _a;
        if (!user || !permissions.length) {
            return [];
        }
        // Admin has access to all modules
        if (((_a = user.role) === null || _a === void 0 ? void 0 : _a.code) === "admin") {
            return Object.values(permissions_1.MODULES);
        }
        return permissions
            .filter(function (p) {
            return Object.values(p.actions).some(function (allowed) { return allowed === true; });
        })
            .map(function (p) { return p.module; });
    }, [user, permissions]);
    return {
        hasPermission: hasPermission,
        canAccess: canAccess,
        isAdmin: isAdmin,
        isSupervisor: isSupervisor,
        canAuthorizeOrders: canAuthorizeOrders,
        userModules: userModules,
    };
}
